
  <!-- Sidebar -->
  <app-sidebar></app-sidebar>
  <div >
    <app-header></app-header> 
    <!-- Page Content -->
    <div id="content">
        <app-tipoDocumento></app-tipoDocumento>
    </div>
    <app-footer></app-footer>
</div>
